import {
  useToast as useOriginalToast,
  UseToastOptions,
} from "@chakra-ui/react";
import { ConnectWalletButton } from "components/ConnectWallet";
import { Toast, ToastProps } from "./Toast";

export const useToast = () => {
  const originalToast = useOriginalToast();

  const toast = (
    options: ToastProps & UseToastOptions & { showConnect?: boolean }
  ) => {
    const children = options.showConnect ? <ConnectWalletButton /> : undefined;

    originalToast({
      ...options,
      position: "top-right",
      render: ({ onClose }) => (
        <Toast {...options} children={children} onClose={onClose} />
      ),
    });
  };
  return toast;
};
